import { LegalShell, LegalSection } from "@/components/site/LegalShell";

export default function ImpressumPage() {
  return (
    <LegalShell kicker="Rechtliches" title="Impressum">
      <LegalSection heading="Kontaktadresse">
        <p>
          Liberox GmbH
          <br />
          Bodenäckerstrasse 3
          <br />
          8957 Spreitenbach
        </p>
      </LegalSection>

      <LegalSection heading="Vertretungsberechtigte Personen">
        <p>
          Nikson Karrica
          <br />
          Inhaber und Geschäftsführer
        </p>
      </LegalSection>

      <LegalSection heading="Kontakt">
        <p>
          Telefon:{" "}
          <a
            href="tel:+41565616762"
            className="transition-colors hover:text-[color:var(--lx-green-soft)]"
            style={{ color: "var(--lx-text)" }}
          >
            +41 56 561 67 62
          </a>
          <br />
          E-Mail:{" "}
          <a
            href="mailto:labs@liberox.ch"
            className="transition-colors hover:text-[color:var(--lx-green-soft)]"
            style={{ color: "var(--lx-text)" }}
          >
            labs@liberox.ch
          </a>
        </p>
      </LegalSection>

      <LegalSection heading="Handelsregistereintrag">
        <p>
          Eingetragener Firmenname: Liberox GmbH
          <br />
          Unternehmens-Identifikationsnummer (UID): CHE-265.395.466
        </p>
      </LegalSection>

      <LegalSection heading="Haftungsausschluss">
        <p>
          Die Liberox GmbH übernimmt keinerlei Gewähr hinsichtlich der
          inhaltlichen Richtigkeit, Genauigkeit, Aktualität, Zuverlässigkeit und
          Vollständigkeit der Informationen auf dieser Website.
        </p>
        <p>
          Haftungsansprüche gegen die Liberox GmbH wegen Schäden materieller oder
          immaterieller Art, welche aus dem Zugriff oder der Nutzung bzw.
          Nichtnutzung der veröffentlichten Informationen, durch Missbrauch der
          Verbindung oder durch technische Störungen entstanden sind, werden
          ausgeschlossen.
        </p>
      </LegalSection>

      <LegalSection heading="Urheberrechte">
        <p>
          Die Urheber- und alle anderen Rechte an Inhalten, Bildern, Fotos oder
          sonstigen Dateien auf dieser Website gehören ausschliesslich der
          Liberox GmbH oder den speziell genannten Rechtsinhabern. Für die
          Reproduktion jeglicher Elemente ist die schriftliche Zustimmung der
          Urheberrechtsträger im Voraus einzuholen.
        </p>
      </LegalSection>
    </LegalShell>
  );
}
